import React, { Component } from "react";
import "../Register/register.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import logo from "../../assets/img/mks_logo.png";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
// import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from "@material-ui/core/StepConnector";
import StepButton from "@material-ui/core/StepButton";
// import Button from '@material-ui/core/Button';
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import "../../assets/css/load.css";
import { PulseLoader } from "react-spinners";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import axios from "axios";
import conf from "../../conf.json";

const styles = theme => ({
  root: {
    width: "90%"
  },
  button: {
    marginRight: theme.spacing.unit
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  connectorActive: {
    "& $connectorLine": {
      borderColor: theme.palette.secondary.main
    }
  },
  connectorCompleted: {
    "& $connectorLine": {
      borderColor: theme.palette.primary.main
    }
  },
  connectorDisabled: {
    "& $connectorLine": {
      borderColor: theme.palette.grey[100]
    }
  },
  connectorLine: {
    transition: theme.transitions.create("border-color")
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  }
});

function getSteps() {
  return ["ขั้นตอนที่ 1", "ขั้นตอนที่ 2", "ขั้นตอนที่ 3"];
}

class Register extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      activeStep: 0,
      position: "",
      openSelect: false,
      openSelectPosiition: false,
      emID: "",
      tel: "",
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      cardID: "",
      password: "",
      con_password: "",
      haveOneID: false,
      loading: false,
      oneId: "",
      formError: {
        emID: "",
        firstname: "",
        lastname: "",
        tel: "",
        email: "",
        cardID: "",
        username: "",
        password: "",
        con_password: ""
      }
    };
    this.getStepContent = this.getStepContent.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.validateOneId = this.validateOneId.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.toggleOneid = this.toggleOneid.bind(this);
    this.handlePosiitionChange = this.handlePosiitionChange.bind(this);
    this.register = this.register.bind(this);
    this.nextStepThree = this.nextStepThree.bind(this);
  }

  

  register() {
    const params = {
      acusername: this.state.username,
      acpassword: this.state.password,
      acpopulation_id: this.state.cardID,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      email: this.state.email,
      id: this.state.emID,
      tel: this.state.tel,
      position: this.state.position,
      haveOne: this.state.haveOneID,
      one_id: this.state.oneId
    };
    this.setState({
      loading: true
    });
    if (this.state.password === this.state.con_password) {
      axios
        .post(conf.url + "/register", JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          //console.log(res);
          if (res.status === 200) {
            alert("สมัครสมาชิกสำเร็จ");
            window.location.assign("/");
          }
        })
        .catch(err => {
          alert("กรุณาตรวจสอบข้อมูล หรือ user นี้มีอยู่แล้ว");
        });
    } else {
      alert("รหัสผ่านไม่ถูกต้อง");
    }
    this.setState({
      loading: false
    });
  }

  handleValidation(){
    let formIsValid = true;

    if (this.state.con_password != this.state.password){
      formIsValid = false;
      this.setState({
        formError: {
          con_password: "ยืนยันรหัสผ่านไม่ตรงกัน",
        }
      })
    }

    if (!this.state.con_password){
      formIsValid = false;
      this.setState({
        formError: {
          con_password: "กรุณากรอกยืนยันรหัสผ่าน",
        }
      })
    }

    if (!this.state.password){
      formIsValid = false;
      this.setState({
        formError: {
          password: "กรุณากรอกรหัสผ่าน",
        }
      })
    }else if (this.state.password != ""){
      if (!this.state.password.match(/^(?=.*[A-Za-z])(?=.*[0-9]).{8,32}$/)){
        formIsValid = false;
        this.setState({
          formError: {
            password: "ตัวอักษรภาษาอังกฤษพิมพ์เล็กหรือพิมพ์ใหญ่และตัวเลขอย่างน้อย 8 ตัว",
          }
        })
      }
    }

    if (!this.state.username){
      formIsValid = false;
      this.setState({
        formError: {
          username: "กรุณากรอกชื่อผู้ใช้งาน",
        }
      })
    }else if (this.state.username != ""){
      if (!this.state.username.match(/^(?=.*[A-Za-z]).{6,32}$/)){
        formIsValid = false;
        this.setState({
          formError: {
            username: "ตัวอักษรภาษาอังกฤษอย่างน้อย 6 ตัว",
          }
        })
      }
    }

    if (!this.state.cardID){
      formIsValid = false;
      this.setState({
        formError: {
          cardID: "กรุณากรอกเลขบัตรประจำตัวประชาชน",
        }
      })
    }

    if (!this.state.email){
      formIsValid = false;
      this.setState({
        formError: {
          email: "กรุณากรอกEmail",
        }
      })
    }

    if (!this.state.tel){
      formIsValid = false;
      this.setState({
        formError: {
          tel: "กรุณากรอกเบอร์โทร",
        }
      })
    }

    if (!this.state.lastname){
      formIsValid = false;
      this.setState({
        formError: {
          lastname: "กรุณากรอกนามสกุล",
        }
      })
    }else if (this.state.lastname != ""){
      if (this.state.lastname.match(/^[u0E01-u0E5B]+$/)){
        formIsValid = false;
        this.setState({
          formError: {
            lastname: "กรุณากรอกนามสกุลภาษาไทย",
          }
        })
      }
    }

    if (!this.state.firstname){
      formIsValid = false;
      this.setState({
        formError: {
          firstname: "กรุณากรอกชื่อ",
        }
      })
    }else if (this.state.firstname != ""){
      if (this.state.firstname.match(/^[u0E01-u0E5B]+$/)){
        formIsValid = false;
        this.setState({
          formError: {
            firstname: "กรุณากรอกชื่อภาษาไทย",
          }
        })
      }
    }

    if (!this.state.emID){
      formIsValid = false;
      this.setState({
        formError: {
          emID: "กรุณากรอกรหัสพนักงาน",
        }
      })
    }
    return formIsValid;
  }

  nextStepThree(e){
    e.preventDefault();
    if(this.handleValidation()){
      this.setState({ activeStep: 2 })
    }
  }

  handleStep = step => () => {
    this.setState({
      activeStep: step
    });
  };

  handlePosiitionChange = event => {
    this.setState({
      position: event.target.value
    });
  };

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };
  toggleOneid() {
    this.setState(prevState => ({
      modalOneid: !prevState.modalOneid
    }));
  }

  handleReset = () => {
    this.setState({
      activeStep: 0
    });
  };

  handleSelectChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSelectClose = () => {
    this.setState({ openSelect: false });
  };

  handleSelectOpen = () => {
    this.setState({ openSelect: true });
  };

  handlePositionChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handlePositionClose = () => {
    this.setState({ openSelectPosiition: false });
  };

  handlePositionOpen = () => {
    this.setState({ openSelectPosiition: true });
  };

  toggle1() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggle(tab) {
    this.setState({
      activeTab: tab
    });
  }
  getStepContent(stepIndex, state, classes) {
    switch (stepIndex) {
      case 0:
        return (
          <div
            className="text-center"
            style={{
              border: "1px solid black",
              padding: " 15px 15px 0px 15px"
            }}
          >
            {this.state.loading && (
              <PulseLoader sizeUnit={"px"} size={50} color={"#F48F0C"} />
            )}
            <div className="row">
              <div className="col-12 col-sm-6">
                <FormGroup>
                  <Button
                    onClick={() =>
                      this.setState({
                        activeStep: 1
                      })
                    }
                    disabled={this.state.loading}
                    className="btn-block"
                    style={{ height: "185px" }}
                    color="secondary"
                  >
                    ยังไม่มี One ID
                  </Button>
                </FormGroup>
              </div>
              {/* <div className="col-12 col-sm-2 ">
              <FormGroup>
                <h3 className="legend"><span>หรือ</span></h3>
              </FormGroup>
            </div> */}
              <div className="col-12 col-sm-6">
                <FormGroup>
                  <Button
                    className="btn-block"
                    style={{ height: "185px" }}
                    color="info"
                    onClick={this.toggleOneid}
                  >
                    มี One ID
                  </Button>
                </FormGroup>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div
            className="pt-3 text-center"
            style={{ padding: "15px", border: "1px solid gray" }}
          >
            <div className="row">
              <div className="col">
                <FormGroup>
                  <h3 className="legend">
                    <span>ข้อมูลผู้ใช้</span>
                  </h3>
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-7"
                style={{ textAlign: "left", padding: "15px" }}
              >
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-6"
                    style={{ textAlign: "left" }}
                  >
                    <FormGroup>
                      <Label for="empid"><b style={{ color: "red" }}>*</b>รหัสพนักงาน</Label>
                      <Input
                        value={this.state.emID}
                        onChange={this.handleInput}
                        type="text"
                        name="emID"
                        id="emID"
                        className="required"
                      />
                      <div style={{ color: "red" }}>
                        {this.state.formError.emID}
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label for="noneoneidname"><b style={{ color: "red" }}>*</b>ชื่อ</Label>
                      <Input
                        value={this.state.firstname}
                        onChange={this.handleInput}
                        type="text"
                        name="firstname"
                        id="firstname"
                        className="required"
                      />
                      <div style={{ color: "red" }}>
                        {this.state.formError.firstname}
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label for="noneoneidlastname"><b style={{ color: "red" }}>*</b>นามสกุล</Label>
                      <Input
                        value={this.state.lastname}
                        onChange={this.handleInput}
                        type="text"
                        name="lastname"
                        id="lastname"
                        className="required"
                      />
                      <div style={{ color: "red" }}>
                        {this.state.formError.lastname}
                      </div>
                    </FormGroup>
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-6"
                    style={{ textAlign: "left" }}
                  >
                    <FormGroup>
                      <Label for="tel"><b style={{ color: "red" }}>*</b>เบอร์โทร</Label>
                      <Input
                        onChange={this.handleInput}
                        id="tel"
                        name="tel"
                        type="text"
                        value={this.state.tel}
                        className="required"
                      />
                      <div style={{ color: "red" }}>
                        {this.state.formError.tel}
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label for="email"><b style={{ color: "red" }}>*</b>Email</Label>
                      <Input
                        type="text"
                        value={this.state.email}
                        onChange={this.handleInput}
                        name="email"
                        id="email"
                        className="required"
                      />
                      <div style={{ color: "red" }}>
                        {this.state.formError.email}
                      </div>
                    </FormGroup>
                    <FormGroup>
                      <Label for="citizen"><b style={{ color: "red" }}>*</b>เลขบัตรประจำตัวประชาชน</Label>
                      <Input
                        value={this.state.cardID}
                        onChange={this.handleInput}
                        type="text"
                        name="cardID"
                        id="cardID"
                        className="required"
                      />
                      <div style={{ color: "red" }}>
                        {this.state.formError.cardID}
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-5">
                <div style={{ textAlign: "left", padding: "15px" }}>
                  <FormGroup>
                    <Label for="UsernameOneId"><b style={{ color: "red" }}>*</b>ชื่อผู้ใช้งาน</Label>
                    <Input
                      type="text"
                      value={this.state.username}
                      onChange={this.handleInput}
                      name="username"
                      id="username"
                      disabled={this.state.haveOneID}
                      className="required"
                    />
                    <div style={{ color: "red" }}>
                        {this.state.formError.username}
                      </div>
                  </FormGroup>

                  <FormGroup>
                    <Label for="passwordOneId"><b style={{ color: "red" }}>*</b>รหัสผ่าน</Label>
                    <Input
                      value={this.state.password}
                      onChange={this.handleInput}
                      disabled={this.state.haveOneID}
                      type="password"
                      name="password"
                      id="password"
                      className="required"
                    />
                    <div style={{ color: "red" }}>
                        {this.state.formError.password}
                      </div>
                  </FormGroup>
                  <FormGroup>
                    <Label for="confirmPassword"><b style={{ color: "red" }}>*</b>ยืนยันรหัสผ่าน</Label>
                    <Input
                      value={this.state.con_password}
                      onChange={this.handleInput}
                      disabled={this.state.haveOneID}
                      type="password"
                      name="con_password"
                      id="con_password"
                      className="required"
                    />
                    <div style={{ color: "red" }}>
                        {this.state.formError.con_password}
                      </div>
                  </FormGroup>
                  {/* <FormGroup check>
                  <Label>
                    <Input className="" type="checkbox" style={{ width: "20px", height: "20px"}} />{' '}
                    ยอมรับเงื่อนไข
                  </Label>
                </FormGroup> */}
                  
                </div>
              </div>
              
            </div>
            <div className="text-right">
              <FormGroup>
                <Button
                  // onClick={() => this.setState({ activeStep: 2 })}
                  onClick={this.nextStepThree}
                  className="btn"
                  style={{ height: "50px" }}
                  color="info"
                >
                  ถัดไป
                </Button>
              </FormGroup>
            </div>
            <br />
          </div>
        );
      case 2:
        return (
          <div
            className="pt-3 text-center"
            style={{ padding: "15px", border: "1px solid gray" }}
          >
            <div className="row">
              <div className="col">
                <FormGroup>
                  <h3 className="legend">
                    <span>ตรวจสอบข้อมูล</span>
                  </h3>
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-12"
                style={{ textAlign: "left", padding: "15px" }}
              >
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-6 col-md-4"
                    style={{ textAlign: "left" }}
                  >
                    <FormGroup>
                      <Label for="UsernameOneId">ชื่อผู้ใช้งาน</Label>
                      <Input
                        type="text"
                        value={this.state.username}
                        disabled
                        className="required"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="empid">รหัสพนักงาน</Label>
                      <Input
                        type="text"
                        value={this.state.emID}
                        className="required"
                        disabled
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="tel">เบอร์โทร</Label>
                      <Input
                        type="text"
                        value={this.state.tel}
                        className="required"
                        disabled
                      />
                    </FormGroup>
                    <FormControl
                      style={{ width: "260px" }}
                      className={classes.formControl}
                    >
                      
                    </FormControl>
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-4"
                    style={{ textAlign: "left" }}
                  >
                    <FormGroup>
                      <Label for="noneoneidname">ชื่อ</Label>
                      <Input
                        value={this.state.firstname}
                        type="text"
                        className="required"
                        disabled
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input
                        value={this.state.email}
                        type="text"
                        className="required"
                        disabled
                      />
                    </FormGroup>
                  </div>
                  <div
                    className="col-xs-12 col-sm-6 col-md-4"
                    style={{ textAlign: "left" }}
                  >
                    <FormGroup>
                      <Label for="noneoneidlastname">นามสกุล</Label>
                      <Input
                        value={this.state.lastname}
                        type="text"
                        name="noneoneidlastname"
                        id="noneoneidlastname"
                        className="required"
                        disabled
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="citizen">เลขบัตรประจำตัวประชาชน</Label>
                      <Input
                        value={this.state.cardID}
                        type="text"
                        name="citizen"
                        id="citizen"
                        className="required"
                        disabled
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-right">
              <Button
                disabled={this.state.loading}
                className="btn"
                style={{ height: "50px" }}
                color="success"
                onClick={this.register}
              >
                ยืนยัน
              </Button>
            </div>
            <br />
          </div>
        );
      default:
        return "Unknown stepIndex";
    }
  }

  handleInput = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };
  validateOneId() {
    const params = {
      username: this.state.chusername,
      password: this.state.chpassword
    };
    this.setState({
      loading: true
    });
    axios
      .post(conf.url + "/register/get", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
       // console.log(res);
        if (res.status === 200) {
          console.log(res)
          this.toggleOneid();
          alert("พบผู้ใช้งาน!");
          this.setState({
            activeStep: 1,
            emID: "",
            username: this.state.chusername,
            firstname: res.data.first_name_th,
            lastname: res.data.last_name_th,
            tel: res.data.mobile[0].mobile_no,
            email: res.data.thai_email,
            cardID: "",
            password:this.state.chpassword,
            con_password: this.state.chpassword,
            haveOneID: true,
            loading: false,
            oneId: res.data.id
          });
        } else {
          this.setState({
            loading: false
          });
          alert("ไม่พบผู้ใช้งาน");
        }
      })
      .catch(err => {
        console.log(err)
        alert("ไม่พบผู้ใช้งาน");
      });
  }

  handleStep = step => () => {
    this.setState({
      activeStep: step
    });
  };

  

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    }));
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0
    });
  };

  handleSelectChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSelectClose = () => {
    this.setState({ openSelect: false });
  };

  handleSelectOpen = () => {
    this.setState({ openSelect: true });
  };

  handlePositionChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handlePositionClose = () => {
    this.setState({ openSelectPosiition: false });
  };

  handlePositionOpen = () => {
    this.setState({ openSelectPosiition: true });
  };

  toggle1() {
    this.setState({ collapse: !this.state.collapse });
  }

  toggle(tab) {
    this.setState({
      activeTab: tab
    });
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;
    const connector = (
      <StepConnector
        classes={{
          active: classes.connectorActive,
          completed: classes.connectorCompleted,
          disabled: classes.connectorDisabled,
          line: classes.connectorLine
        }}
      />
    );
    return (
      <div className="background-image">
        <div className="paper-style">
          <Paper elevation={5} className="paper-card">
            <div className="form-regis">
              <div style={{ padding: "15px", textDecoration: "underline" }}>
                <a href="/" role="button">
                  <h6>กลับหน้าหลัก</h6>
                </a>
              </div>
              <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-xs-12 col-sm-10 col-md-5">
                  <img
                    src={logo}
                    className="responsive ml-auto mr-auto"
                    alt="logo"
                  />
                </div>
              </div>

              <div style={{ padding: "15px" }}>
                <Stepper
                  activeStep={activeStep}
                  nonLinear
                  connector={connector}
                >
                  {steps.map((label, index) => (
                    <Step key={label}>
                      <StepButton onClick={this.handleStep(index)}>
                        {label}
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
                <div>
                  {this.state.activeStep === steps.length ? (
                    <div>
                      <Typography className={classes.instructions}>
                        All steps completed
                      </Typography>
                      <Button onClick={this.handleReset}>Reset</Button>
                    </div>
                  ) : (
                    <div>
                      <Typography className={classes.instructions}>
                        {this.getStepContent(
                          activeStep,
                          this.state,
                          this.props
                        )}
                      </Typography>
                      {/* <div>
                          <Button
                            disabled={activeStep === 0}
                            onClick={this.handleBack}
                            className={classes.backButton}
                          >
                            Back
                          </Button>
                          <Button variant="contained" color="primary" onClick={this.handleNext}>
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                          </Button>
                        </div> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Paper>
        </div>
        <Modal
          className="modal-oneid"
          isOpen={this.state.modalOneid}
          toggle={this.toggleOneid}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleOneid}>มี One ID</ModalHeader>
          <ModalBody>
            <div className="row">
              <div
                className="col-8"
                style={{ textAlign: "left", padding: "20px" }}
              >
                <FormGroup>
                  <Label for="nameoneid">ชื่อผู้ใช้งาน</Label>
                  <Input
                    value={this.state.chusername}
                    onChange={this.handleInput}
                    type="text"
                    name="chusername"
                    id="usernameoneid"
                    placeholder="ชื่อผู้ใช้งาน"
                    className="required"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="passwordoneid">รหัสผ่าน</Label>
                  <Input
                    onChange={this.handleInput}
                    value={this.state.chpassword}
                    type="password"
                    name="chpassword"
                    id="passwordoneid"
                    placeholder="รหัสผ่าน"
                    className="required"
                  />
                </FormGroup>
              </div>
              <div className="col-4" style={{ marginLeft: "-15px" }}>
                <FormGroup className="text-center mt-4">
                  <Button
                    disabled={this.state.loading}
                    onClick={this.validateOneId}
                    className="btn btn-block"
                    style={{ height: "160px" }}
                    color="info"
                  >
                    <h4>ตรวจสอบ</h4>
                  </Button>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              disabled={this.state.loading}
              onClick={this.toggleOneid}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

Register.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(Register);



// WEBPACK FOOTER //
// ./src/views/Register/Register.jsx